import React from 'react';
import { benches } from '../data/mock';
import BenchCard from './BenchCard';

const BenchesSection = () => {
  return (
    <section id="benches" className="py-24 bg-[#0a0a0a]" data-testid="benches-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[#FF6B00] font-bold text-sm uppercase tracking-wider">
            Nossa Estrutura
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6">
            Bancadas de <span className="text-[#FF6B00]">Teste</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            Equipamentos de última geração para diagnóstico e teste de todo o sistema de injeção diesel
          </p>
        </div>

        <div className="space-y-16">
          {benches.map((bench, index) => (
            <BenchCard key={bench.id} bench={bench} reversed={index % 2 === 1} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenchesSection;
